export default __webpack_public_path__ + "05bf3e647e3bd4ec711796d9324f06d1.png";